import * as React from 'react';
import { withRouter } from 'react-router-dom';

export const ScrollToTop = withRouter(class extends React.Component<any> {
    componentDidUpdate(prevProps: any) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return this.props.children;
    }
});



// WEBPACK FOOTER //
// ./assets/js/components/ScrollToTop.tsx